const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')

const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const guest = () => import(/* webpackPrefetch: true */ '@/views/private/guest/index.vue')
const guest_detail = () => import(/* webpackPrefetch: true */ '@/views/private/guest/_id.vue')
const guest_add = () => import(/* webpackPrefetch: true */ '@/views/private/guest/add/index.vue')
const guest_edit = () => import(/* webpackPrefetch: true */ '@/views/private/guest/edit/_id.vue')

const order = () => import(/* webpackPrefetch: true */ '@/views/private/order/index.vue')

const service = () => import(/* webpackPrefetch: true */ '@/views/private/service/index.vue')

const facility = () => import(/* webpackPrefetch: true */ '@/views/private/facility/index.vue')
const facility_add = () => import(/* webpackPrefetch: true */ '@/views/private/facility/add/index.vue')
const facility_edit = () => import(/* webpackPrefetch: true */ '@/views/private/facility/edit/_id.vue')

const attraction = () => import(/* webpackPrefetch: true */ '@/views/private/attraction/index.vue')
const attraction_add = () => import(/* webpackPrefetch: true */ '@/views/private/attraction/add/index.vue')
const attraction_edit = () => import(/* webpackPrefetch: true */ '@/views/private/attraction/edit/_id.vue')

const food = () => import(/* webpackPrefetch: true */ '@/views/private/food/index.vue')
const food_add = () => import(/* webpackPrefetch: true */ '@/views/private/food/add/index.vue')
const food_edit = () => import(/* webpackPrefetch: true */ '@/views/private/food/edit/_id.vue')

const room = () => import(/* webpackPrefetch: true */ '@/views/private/room/index.vue')
const room_add = () => import(/* webpackPrefetch: true */ '@/views/private/room/add/index.vue')
const room_edit = () => import(/* webpackPrefetch: true */ '@/views/private/room/edit/_id.vue')

const greeting = () => import(/* webpackPrefetch: true */ '@/views/private/greeting/index.vue')

const text = () => import(/* webpackPrefetch: true */ '@/views/private/text/index.vue')

const channel = () => import(/* webpackPrefetch: true */ '@/views/private/channel/index.vue')
const channel_add = () => import(/* webpackPrefetch: true */ '@/views/private/channel/add/index.vue')
const channel_edit = () => import(/* webpackPrefetch: true */ '@/views/private/channel/edit/_id.vue')

const category = () => import(/* webpackPrefetch: true */ '@/views/private/category/index.vue')
const category_add = () => import(/* webpackPrefetch: true */ '@/views/private/category/add/index.vue')
const category_edit = () => import(/* webpackPrefetch: true */ '@/views/private/category/edit/_id.vue')

const prayer = () => import(/* webpackPrefetch: true */ '@/views/private/extra/prayer/index.vue')
const prayer_add = () => import(/* webpackPrefetch: true */ '@/views/private/extra/prayer/add/index.vue')
const prayer_edit = () => import(/* webpackPrefetch: true */ '@/views/private/extra/prayer/edit/_id.vue')

const ads = () => import(/* webpackPrefetch: true */ '@/views/private/extra/ads/index.vue')

const group_greeting = () => import(/* webpackPrefetch: true */ '@/views/private/extra/greeting/index.vue')
const group_greeting_add = () => import(/* webpackPrefetch: true */ '@/views/private/extra/greeting/add/index.vue')
const group_greeting_edit = () => import(/* webpackPrefetch: true */ '@/views/private/extra/greeting/edit/_id.vue')

const nursing = () => import(/* webpackPrefetch: true */ '@/views/private/nursing/index.vue')
const nursing_add = () => import(/* webpackPrefetch: true */ '@/views/private/nursing/add/index.vue')
const nursing_edit = () => import(/* webpackPrefetch: true */ '@/views/private/nursing/edit/_id.vue')

const emergency = () => import(/* webpackPrefetch: true */ '@/views/private/extra/emergency/index.vue')
const emergency_add = () => import(/* webpackPrefetch: true */ '@/views/private/extra/emergency/add/index.vue')
const emergency_edit = () => import(/* webpackPrefetch: true */ '@/views/private/extra/emergency/edit/_id.vue')

const cctv = () => import(/* webpackPrefetch: true */ '@/views/private/cctv/index.vue')
const cctv_add = () => import(/* webpackPrefetch: true */ '@/views/private/cctv/add/index.vue')
const cctv_edit = () => import(/* webpackPrefetch: true */ '@/views/private/cctv/edit/_id.vue')

const cctv_detail = () => import(/* webpackPrefetch: true */ '@/views/private/cctv/detail/_id.vue')
const cctv_detail_add = () => import(/* webpackPrefetch: true */ '@/views/private/cctv/detail/add/_id.vue')
const cctv_detail_edit = () => import(/* webpackPrefetch: true */ '@/views/private/cctv/detail/edit/_id.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },

  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },


  {
    path: "/guest",
    name: "Guest Room",
    component: guest,
    meta: {
      title: "Guest Room"
    }
  },
  {
    path: "/guest/:id",
    name: "Guest Room Detail",
    component: guest_detail,
    meta: {
      title: "Guest Room Detail"
    }
  },
  {
    path: "/guest/add/checkin",
    name: "Guest Room Check In",
    component: guest_add,
    meta: {
      title: "Guest Room Check In"
    }
  },
  // {
  //   path: "/guest/edit/checkin/:id",
  //   name: "Guest Room Checkin",
  //   component: guest_edit,
  //   meta: {
  //     title: "Guest Room Checkin"
  //   }
  // },


  {
    path: "/order",
    name: "Food Order",
    component: order,
    meta: {
      title: "Food Order"
    }
  },


  {
    path: "/service",
    name: "Services Request",
    component: service,
    meta: {
      title: "Services Request"
    }
  },


  {
    path: "/facility",
    name: "Facilities",
    component: facility,
    meta: {
      title: "Facilities"
    }
  },
  {
    path: "/facility/add",
    name: "Facilities Add",
    component: facility_add,
    meta: {
      title: "Facilities Add"
    }
  },
  {
    path: "/facility/edit/:id",
    name: "Facilities Edit",
    component: facility_edit,
    meta: {
      title: "Facilities Edit"
    }
  },


  {
    path: "/attraction",
    name: "Nearby Attractions",
    component: attraction,
    meta: {
      title: "Nearby Attractions"
    }
  },
  {
    path: "/attraction/add",
    name: "Nearby Attractions Add",
    component: attraction_add,
    meta: {
      title: "Nearby Attractions Add"
    }
  },
  {
    path: "/attraction/edit/:id",
    name: "Nearby Attractions Edit",
    component: attraction_edit,
    meta: {
      title: "Nearby Attractions Edit"
    }
  },


  {
    path: "/food",
    name: "Food Menu",
    component: food,
    meta: {
      title: "Food Menu"
    }
  },
  {
    path: "/food/add",
    name: "Food Menu Add",
    component: food_add,
    meta: {
      title: "Food Menu Add"
    }
  },
  {
    path: "/food/edit/:id",
    name: "Food Menu Edit",
    component: food_edit,
    meta: {
      title: "Food Menu Edit"
    }
  },


  {
    path: "/room",
    name: "Hotel Services",
    component: room,
    meta: {
      title: "Hotel Services"
    }
  },
  {
    path: "/room/add",
    name: "Hotel Services Add",
    component: room_add,
    meta: {
      title: "Hotel Services Add"
    }
  },
  {
    path: "/room/edit/:id",
    name: "Hotel Services Edit",
    component: room_edit,
    meta: {
      title: "Hotel Services Edit"
    }
  },


  {
    path: "/greeting",
    name: "GM Greetings",
    component: greeting,
    meta: {
      title: "GM Greetings"
    }
  },


  {
    path: "/text",
    name: "Text Rotator",
    component: text,
    meta: {
      title: "Text Rotator"
    }
  },


  {
    path: "/channel",
    name: "Linear Channel",
    component: channel,
    meta: {
      title: "Linear Channel"
    }
  },
  {
    path: "/channel/add",
    name: "Linear Channel Add",
    component: channel_add,
    meta: {
      title: "Linear Channel Add"
    }
  },
  {
    path: "/channel/edit/:id",
    name: "Linear Channel Edit",
    component: channel_edit,
    meta: {
      title: "Linear Channel Edit"
    }
  },

  {
    path: "/category",
    name: "Room Type",
    component: category,
    meta: {
      title: "Room Type"
    }
  },
  {
    path: "/category/add",
    name: "Room Type Add",
    component: category_add,
    meta: {
      title: "Room Type Add"
    }
  },
  {
    path: "/category/edit/:id",
    name: "Room Type Edit",
    component: category_edit,
    meta: {
      title: "Room Type Edit"
    }
  },

  {
    path: "/extra/prayer",
    name: "Doa Harian",
    component: prayer,
    meta: {
      title: "Doa Harian"
    }
  },
  {
    path: "/extra/prayer/add",
    name: "Doa Harian Add",
    component: prayer_add,
    meta: {
      title: "Doa Harian Add"
    }
  },
  {
    path: "/extra/prayer/edit/:id",
    name: "Doa Harian Edit",
    component: prayer_edit,
    meta: {
      title: "Doa Harian Edit"
    }
  },

  {
    path: "/extra/ads",
    name: "Public Ads",
    component: ads,
    meta: {
      title: "Public Ads"
    }
  },

  {
    path: "/extra/greeting",
    name: "Group Greeting",
    component: group_greeting,
    meta: {
      title: "Group Greeting"
    }
  },
  {
    path: "/extra/greeting/add",
    name: "Group Greeting Add",
    component: group_greeting_add,
    meta: {
      title: "Group Greeting Add"
    }
  },
  {
    path: "/extra/greeting/edit/:id",
    name: "Group Greeting Edit",
    component: group_greeting_edit,
    meta: {
      title: "Group Greeting Edit"
    }
  },



  {
    path: "/nursing",
    name: "Nursing",
    component: nursing,
    meta: {
      title: "Nursing"
    }
  },
  {
    path: "/nursing/add",
    name: "Nursing Add",
    component: nursing_add,
    meta: {
      title: "Nursing Add"
    }
  },
  {
    path: "/nursing/edit/:id",
    name: "Nursing Edit",
    component: nursing_edit,
    meta: {
      title: "Nursing Edit"
    }
  },



  {
    path: "/extra/emergency",
    name: "Emergency",
    component: emergency,
    meta: {
      title: "Emergency"
    }
  },
  {
    path: "/extra/emergency/add",
    name: "Emergency Add",
    component: emergency_add,
    meta: {
      title: "Emergency Add"
    }
  },
  {
    path: "/extra/emergency/edit/:id",
    name: "Emergency Edit",
    component: emergency_edit,
    meta: {
      title: "Emergency Edit"
    }
  },


  {
    path: "/cctv",
    name: "CCTV",
    component: cctv,
    meta: {
      title: "CCTV"
    }
  },
  {
    path: "/cctv/add",
    name: "CCTV Add",
    component: cctv_add,
    meta: {
      title: "CCTV Add"
    }
  },
  {
    path: "/cctv/edit/:id",
    name: "CCTV Edit",
    component: cctv_edit,
    meta: {
      title: "CCTV Edit"
    }
  },

  {
    path: "/cctv/detail/:id",
    name: "CCTV Detail",
    component: cctv_detail,
    meta: {
      title: "CCTV Detail"
    }
  },
  {
    path: "/cctv/detail/add/:id",
    name: "CCTV Detail Add",
    component: cctv_detail_add,
    meta: {
      title: "CCTV Detail Add"
    }
  },
  {
    path: "/cctv/detail/edit/:id",
    name: "CCTV Detail Edit",
    component: cctv_detail_edit,
    meta: {
      title: "CCTV Detail Edit"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})